import type { ReactNode } from "react";

type PageShellProps = {
  children: ReactNode;
  width?: "content" | "workspace";
  compactMobile?: boolean;
};

/** Shared hub layout; articles and full-screen chess tools keep their own layouts. */
export default function PageShell({
  children,
  width = "content",
  compactMobile = false,
}: PageShellProps) {
  return (
    <div className="w-full flex-1 bg-athens-gray-100 px-6 sm:px-8">
      <div
        className={`mx-auto min-w-0 pb-12 ${
          compactMobile ? "pt-3 md:pt-10" : "pt-8 md:pt-10"
        } ${width === "workspace" ? "max-w-[1280px]" : "max-w-[1040px]"}`}
      >
        {children}
      </div>
    </div>
  );
}
